import { useLocation } from 'react-router-dom';
import { ReactComponent as Bell } from '../../assets/svg/BellSimple.svg';
import classes from './notification.module.scss';
import { ReactComponent as BellFill } from '../../assets/svg/bell_active.svg';
export const NotificationIcon = ({ data }) => {
    const unreadCount = data?.getNotification?.unreadCount || 0;
    const location = useLocation();
    return (
        <>
            <div className={classes['notification-box']}>
                <div>
                    {location.pathname === '/notifications' ? (
                        <BellFill style={{ color: 'white' }} />
                    ) : (
                        <Bell style={{ color: 'white' }} />
                    )}
                </div>
                {unreadCount > 0 && <div>{unreadCount}</div>}
            </div>
        </>
    );
};
